enum ListTypes {
  whiteList = 'whitelist',
  blackList = 'blacklist',
}

export default ListTypes;
